// extracted by mini-css-extract-plugin
export var indexHolder = "Index-module--indexHolder--2l87X";